function normalizeNetwork(network: string): string {
	return network.trim().toLowerCase()
}

const DEFAULT_SOLANA_MAINNET_RPC_URL = 'https://solana-rpc.publicnode.com'
const DEFAULT_SOLANA_DEVNET_RPC_URL = 'https://solana-devnet-rpc.publicnode.com'

export function getSolanaRpcUrl(network: string): string {
	const normalizedNetwork = normalizeNetwork(network)
	const configuredRpcUrl = normalizedNetwork.includes('devnet') ? import.meta.env.VITE_SOLANA_DEVNET_RPC_URL?.trim() : import.meta.env.VITE_SOLANA_RPC_URL?.trim()

	if (configuredRpcUrl) {
		return configuredRpcUrl
	}

	if (normalizedNetwork.includes('devnet')) {
		return DEFAULT_SOLANA_DEVNET_RPC_URL
	}

	return DEFAULT_SOLANA_MAINNET_RPC_URL
}
